export const reviews = [
  {
    id: 1,
    name: "Sarah Chen",
    title: "Software Engineer",
    rating: 5,
    review: "The detailed cognitive breakdown was great. Enjoyed seeing my strengths across different areas like logical reasoning and pattern recognition."
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    title: "High School Teacher",
    rating: 5,
    review: "Wide range of questions, report had good level of detail"
  },
  {
    id: 3,
    name: "Dr. Emily Watson",
    title: "Research Scientist",
    rating: 5,
    review: "Percentile rankings were exactly what I was after. Glad I found this."
  },
  {
    id: 4,
    name: "James Thompson",
    title: "University Student",
    rating: 5,
    review: "Very thorough results"
  },
  {
    id: 5,
    name: "Priya Patel",
    title: "Marketing Manager",
    rating: 5,
    review: "Happy with my score. Report is good quality and level of detail"
  },
  {
    id: 6,
    name: "Alex Kim",
    title: "Graphic Designer",
    rating: 4,
    review: "Challenging but great feedback at the end"
  },
  {
    id: 7,
    name: "Rachel Green",
    title: "Registered Nurse",
    rating: 5,
    review: "The report was easy to understand with good information. The percentile data really puts things in perspective."
  },
  {
    id: 8,
    name: "David Miller",
    title: "Accountant",
    rating: 4,
    review: "Solid IQ test with good analysis."
  },
  {
    id: 9,
    name: "Jessica Brown",
    title: "Corporate Lawyer",
    rating: 5,
    review: "The cognitive analysis was comprehensive and the comparisons gave me valuable context. Well worth the time investment for such detailed insights."
  }
]

// Helper function to get reviews by rating
export const getReviewsByRating = (rating) => {
  return reviews.filter(review => review.rating === rating)
}

// Helper function to get random reviews
export const getRandomReviews = (count) => {
  const shuffled = [...reviews].sort(() => 0.5 - Math.random())
  return shuffled.slice(0, count)
}

// Helper function to calculate average rating
export const getAverageRating = () => {
  const total = reviews.reduce((sum, review) => sum + review.rating, 0)
  return (total / reviews.length).toFixed(1)
}